import { MyRacAuthProps } from "raci-react-library";
import getPageTemplateBannerAndButtons from "../../hooks/usePage/getPageTemplateBannerAndButtons";
import useMyRacLogin from "../../hooks/useMyRacLogin";
import { ADB2C_CLIENT_ID, ADB2C_DOMAIN, ADB2C_RETURN_URL, ADB2C_TENANT, SILENT_LOGIN_REDIRECT_URL } from "../../constants";

export const racwaAuthProps = {
  clientId: ADB2C_CLIENT_ID,
  tenant: ADB2C_TENANT,
  domain: ADB2C_DOMAIN,
};

export const getMyRacAuthProps = (): Omit<MyRacAuthProps, "children"> => ({
  clientId: ADB2C_CLIENT_ID,
  silentLoginRedirectUrl: SILENT_LOGIN_REDIRECT_URL,
  loginRedirectUrl: ADB2C_RETURN_URL,
  useMyRacLogin: useMyRacLogin,
  requireLogin: false,
  productLinkingErrorProps: getPageTemplateBannerAndButtons(),
});
